var map = {
	"./awwapp_toolbar/aww-logo-small.svg": 748,
	"./awwapp_toolbar/color-wheel.png": 749,
	"./awwapp_toolbar/ic-avatar.svg": 750,
	"./awwapp_toolbar/ic-chat.svg": 751,
	"./awwapp_toolbar/ic-close-black.svg": 752,
	"./awwapp_toolbar/ic-close-red.svg": 753,
	"./awwapp_toolbar/ic-confirm-change.svg": 754,
	"./awwapp_toolbar/ic-edit-name.svg": 755,
	"./awwapp_toolbar/ic-pages-left.svg": 756,
	"./awwapp_toolbar/ic-pages-right.svg": 757,
	"./awwapp_toolbar/ic-rotate.svg": 758,
	"./awwapp_toolbar/ic-voiceactive.svg": 759,
	"./awwapp_toolbar/ic-zoom-in.svg": 760,
	"./awwapp_toolbar/ic-zoom-out.svg": 761,
	"./awwapp_toolbar/ict-color.svg": 762,
	"./awwapp_toolbar/ict-ellipse.svg": 763,
	"./awwapp_toolbar/ict-ellipseFilled.svg": 764,
	"./awwapp_toolbar/ict-eraseArea.svg": 765,
	"./awwapp_toolbar/ict-eraser.svg": 766,
	"./awwapp_toolbar/ict-lineStraight.svg": 767,
	"./awwapp_toolbar/ict-marker.svg": 768,
	"./awwapp_toolbar/ict-pan.svg": 769,
	"./awwapp_toolbar/ict-pencil.svg": 770,
	"./awwapp_toolbar/ict-postit.svg": 771,
	"./awwapp_toolbar/ict-rectangle.svg": 772,
	"./awwapp_toolbar/ict-rectangleFilled.svg": 773,
	"./awwapp_toolbar/ict-select.svg": 774,
	"./awwapp_toolbar/ict-settings.svg": 775,
	"./awwapp_toolbar/ict-text.svg": 776,
	"./awwapp_toolbar/ict-trash.svg": 777,
	"./awwapp_toolbar/ict-undo.svg": 778,
	"./awwapp_toolbar/ict-upload-image.svg": 779,
	"./awwapp_toolbar/ict-upload-pdf.svg": 780,
	"./awwapp_toolbar/ict-upload-ppt.svg": 781,
	"./awwapp_toolbar/ict-upload.svg": 782,
	"./awwapp_toolbar/loader.gif": 783,
	"./background_tile.svg": 784,
	"./empty-avatar.png": 785,
	"./file-icon.png": 786,
	"./keyboard.svg": 787,
	"./lemon_logo_dark.png": 788,
	"./lemon_logo_light.svg": 789,
	"./react_logo.svg": 790,
	"./sad_lemon.png": 791,
	"./student.svg": 792,
	"./teacher.svg": 793,
	"./welcome_splash.jpg": 794,
	"./welcome_splash2.jpg": 795,
	"./whiteboard-bg.svg": 796,
	"./znak.png": 797
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 747;